import { Action } from '@ngrx/store';
import { type } from '@app/store/util';

export const LOAD = type('[Claims] Load Claims');
export const LOAD_SUCCESS = type('[Claims] Load Claims Success');

export const LOAD_DETAIL = type('[Claims] Load Claim Detail');
export const LOAD_DETAIL_SUCCESS = type('[Claims] Load Claim Detail Success');

export const LOAD_ACTIONS = type('[Claims] Load Claim Actions');
export const LOAD_ACTIONS_SUCCESS = type('[Claims] Load Claim Actions Success');

export const UPDATE_APPOINTMENT_ACTIONS = type('[Claims] Update Appointment Actions');
export const UPDATE_INVOLVED_PARTIES_ACTIONS = type('[Claims] Update Involved Parties Actions');
export const UPDATE_DOCUMENT_ACTIONS = type('[Claims] Update Document Actions');

export const LOAD_PROCESS_STEPS = type('[Claims] Load Claim Process Steps');
export const LOAD_PROCESS_STEPS_SUCCESS = type('[Claims] Load Claim Process Steps Success');

export const CANCEL = type('[Claims] Cancel Claim');
export const CANCEL_SUCCESS = type('[Claims] Cancel Claim Success');

export const LOAD_ERROR = type('[Claims] Load Error');

export const SET_SELECTED = type('[Claims] Set Selected');

export class Load implements Action {
    public type: string = LOAD;
    constructor(public payload?: any) {}
}

export class LoadSuccess implements Action {
    public type: string = LOAD_SUCCESS;
    constructor(public payload: any) {}
}

export class LoadDetail implements Action {
    public type: string = LOAD_DETAIL;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadDetailSuccess implements Action {
    public type: string = LOAD_DETAIL_SUCCESS;
    constructor(public payload: any) {}
}

export class LoadActions implements Action {
    public type: string = LOAD_ACTIONS;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadActionsSuccess implements Action {
    public type: string = LOAD_ACTIONS_SUCCESS;
    constructor(public payload: any) {}
}

export class UpdateAppointmentActions implements Action {
    public type: string = UPDATE_APPOINTMENT_ACTIONS;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class UpdateInvolvedPartiesActions implements Action {
    public type: string = UPDATE_INVOLVED_PARTIES_ACTIONS;
    constructor(public payload: { dossier_volgnummer: number, type: string }) {}
}

export class UpdateDocumentActions implements Action {
    public type: string = UPDATE_DOCUMENT_ACTIONS;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadProcessSteps implements Action {
    public type: string = LOAD_PROCESS_STEPS;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadProcessStepsSuccess implements Action {
    public type: string = LOAD_PROCESS_STEPS_SUCCESS;
    constructor(public payload: any) {}
}

export class Cancel implements Action {
    public type: string = CANCEL;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class CancelSuccess implements Action {
    public type: string = CANCEL_SUCCESS;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadError implements Action {
    public type: string = LOAD_ERROR;
    constructor(public payload?: any) {}
}

export class SetSelected implements Action {
    public type: string = SET_SELECTED;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export type Actions
    = Load
    | LoadSuccess
    | LoadDetail
    | LoadDetailSuccess
    | LoadActions
    | LoadActionsSuccess
    | UpdateAppointmentActions
    | UpdateInvolvedPartiesActions
    | UpdateDocumentActions
    | LoadProcessSteps
    | LoadProcessStepsSuccess
    | LoadError
    | Cancel
    | CancelSuccess
    | SetSelected;
